import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import {
  getFeaturedContent,
  getSimilarArtists,
  getTopAlbums,
  getTopTracks,
  isBackstageRightRailActive,
} from '../../../utils';

import ArtistEvents from './ArtistEvents';
import ArtistFeaturedContent from './ArtistFeaturedContent';
import ArtistLatestReleaseGridItem from './ArtistLatestReleaseGridItem';
import ArtistRadioGridItem from './ArtistRadioGridItem';
import ArtistSimilarArtists from './ArtistSimilarArtists';
import ArtistSocialLinks from './ArtistSocialLinks';
import ArtistSplitPane from './ArtistSplitPane';
import ArtistTopAlbums from './ArtistTopAlbums';
import ArtistTopSongs from './ArtistTopSongs';

export const ArtistMainContent = props => {
  const {
    pandoraId,
    shareableUrlPath,
    bio,
    events,
    featuredContentIds,
    isLoading,
    isMobileDevice,
    isRightRailActive,
    latestReleaseId,
    hasRadio,
    artistPlayId,
    topTracks,
    topAlbums,
    albumCount,
    similarArtists,
    twitterUrl,
  } = props;

  const LatestRelease =
    latestReleaseId && !isLoading ? (
      <ArtistLatestReleaseGridItem
        pandoraId={latestReleaseId}
        isRightRailActive={isRightRailActive}
      />
    ) : null;

  const ArtistRadio =
    hasRadio && !isLoading ? (
      <ArtistRadioGridItem
        pandoraId={pandoraId}
        shareableUrlPath={shareableUrlPath}
        isMobileDevice={isMobileDevice}
        hasRadio={hasRadio}
        isRightRailActive={isRightRailActive}
      />
    ) : null;

  return (
    <React.Fragment>
      {bio}
      {events?.size > 0 && <ArtistEvents pandoraId={pandoraId} events={events} />}
      <ArtistSplitPane left={LatestRelease} right={ArtistRadio} />
      <ArtistTopSongs
        artistPlayId={artistPlayId}
        topTracks={topTracks}
        shareableUrlPath={shareableUrlPath}
        isLoading={isLoading}
      />
      <ArtistFeaturedContent featuredContentIds={featuredContentIds} />
      <ArtistTopAlbums
        topAlbums={topAlbums}
        shareableUrlPath={shareableUrlPath}
        albumCount={albumCount}
        isMobileDevice={isMobileDevice}
      />
      <ArtistSimilarArtists similarArtists={similarArtists} />
      <ArtistSocialLinks twitterUrl={twitterUrl} isMobileDevice={isMobileDevice} />
    </React.Fragment>
  );
};

ArtistMainContent.propTypes = {
  pandoraId: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  events: ImmutablePropTypes.listOf(PropTypes.object),
  bio: PropTypes.node,
  isMobileDevice: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  latestReleaseId: PropTypes.string,
  hasRadio: PropTypes.bool,
  isLoading: PropTypes.bool,
  featuredContentIds: ImmutablePropTypes.listOf(PropTypes.string),
  topAlbums: ImmutablePropTypes.listOf(PropTypes.string),
  topTracks: ImmutablePropTypes.listOf(PropTypes.string),
  artistPlayId: PropTypes.string,
  albumCount: PropTypes.number,
  similarArtists: ImmutablePropTypes.listOf(PropTypes.string),
  twitterUrl: PropTypes.string,
};

export function mapStateToProps(state, ownProps) {
  const { pandoraId } = ownProps;
  const details = D.getInDomain('catalog.utils.getCatalogDetailsFromState')(state, pandoraId);
  const annotation = D.getAnnotationsById(state, pandoraId) || BackstageConstants.emptyMap;

  return {
    shareableUrlPath: annotation.get('shareableUrlPath', ''),
    events: D.getInDomain('catalog.utils.getArtistEventsFromState', BackstageConstants.emptyList)(
      state,
      pandoraId,
    ),
    latestReleaseId: details.get('latestRelease', ''),
    hasRadio: annotation.get('hasRadio', false),
    featuredContentIds: getFeaturedContent(state, pandoraId),
    artistPlayId: details.get('artistPlayId', ''),
    albumCount: details.get('albumCount', 0),
    topTracks: getTopTracks(state, pandoraId),
    topAlbums: getTopAlbums(state, pandoraId),
    isMobileDevice: D.Utils.Capabilities.isMobileDevice(state),
    isRightRailActive: isBackstageRightRailActive(state),
    similarArtists: getSimilarArtists(state, pandoraId),
    twitterUrl: details.get('twitterUrl', ''),
  };
}

export default connect(mapStateToProps)(ArtistMainContent);
